import { getBlogPostPath } from './paths';
import type { BlogPost } from './types';

/** Origine pubblica marketing (allineata a sitemap / canonical). */
export const SITE_PUBLIC_ORIGIN = 'https://app.kipify.io';

/**
 * Versione markdown “pulita” dell’articolo (H1, metadati, corpo) per route `.md`
 * o export statico: niente layout React, utile a crawler/agent che preferiscono testo lineare.
 */
export function buildBlogPostPlainMarkdown(post: BlogPost): string {
  const path = getBlogPostPath(post.slug, post.language);
  const canonical = `${SITE_PUBLIC_ORIGIN}${path}`;
  const updated = post.updatedAt || post.publishedAt;
  const author = post.author ?? 'Kipify';

  return [
    `# ${post.title}`,
    '',
    `- **Canonical (HTML):** ${canonical}`,
    `- **Published:** ${post.publishedAt}`,
    `- **Updated:** ${updated}`,
    `- **Author:** ${author}`,
    '',
    post.bodyMarkdown?.trim() ?? '',
    '',
  ].join('\n');
}
